export default __webpack_public_path__ + "static/YouDontHaveCoderto-b622561fe14e419b43d7d79bea2b1f2e.svg";